import './LoadingPage.css'

export const LoadingPage = () => {
  return (
    <div className="smm__loading__container">
      <div className="loader">Loading...</div>
    </div>
  )
}
